/**
=========================================================
* Soft UI Dashboard React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Grid from "@mui/material/Grid";


// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import PlatformSettings from "layouts/profile/components/PlatformSettings";


// Soft UI Dashboard Materail-UI example components
import Table from "examples/Tables/Table";

// Data
import data from "layouts/dashboard/components/Projects/data";

function Projects() {
  const { columns, rows } = data();
  const [menu, setMenu] = useState(null);

  const openMenu = ({ currentTarget }) => setMenu(currentTarget);
  const closeMenu = () => setMenu(null);

  const renderMenu = (
    <Menu
      id="simple-menu"
      anchorEl={menu}
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={Boolean(menu)}
      onClose={closeMenu}
    >
      <MenuItem onClick={closeMenu}>Action</MenuItem>
      <MenuItem onClick={closeMenu}>Another action</MenuItem>
      <MenuItem onClick={closeMenu}>Something else</MenuItem>
    </Menu>
  );

  return (
    <Card>
    <SoftBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
      <SoftBox >
        {/* <a >
          <img src="http://retail.checkus.info/images/stock_banners/voucher_activation_home_page_banner.jpg" alt="Voucher Activation Banner" />
        </a> */}
         <Grid item xs={12} md={6} xl={4}>
            {/* <PlatformSettings /> */}
               <a>
          <img src="http://retail.checkus.info/images/stock_banners/voucher_activation_home_page_banner.jpg" alt="Voucher Activation Banner"  className="dashboard-img"/>
        </a> 
          </Grid>
      </SoftBox>
    </SoftBox>
  </Card>

  );
}

export default Projects;
